module.exports = __webpack_public_path__ + "static/media/picto-engrave-blue.5868dd99.svg";